var _desc, _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMicrobitIllustration(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "116px",
    height: "95px",
    viewBox: "0 0 116 95",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "microbit-illustration") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "microbit-illustration",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "micro-bit",
    transform: "translate(4.000000, 3.500000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M102,0.675 L6,0.675 C2.7,0.675 0,3.375 0,6.675 L0,81.675 C0,84.375 1.725,86.625 4.125,87.375 C4.725,87.525 5.325,87.675 6,87.675 L102,87.675 C102.675,87.675 103.275,87.6 103.875,87.375 C106.275,86.625 108,84.375 108,81.675 L108,6.675 C108,3.375 105.375,0.675 102,0.675 Z M9,76.725 C6.9,76.725 5.25,75.075 5.25,72.975 C5.25,70.875 6.9,69.225 9,69.225 C11.1,69.225 12.75,70.875 12.75,72.975 C12.75,75.075 11.1,76.725 9,76.725 Z M30.225,76.725 C28.125,76.725 26.475,75.075 26.475,72.975 C26.475,70.875 28.125,69.225 30.225,69.225 C32.325,69.225 33.975,70.875 33.975,72.975 C33.975,75.075 32.25,76.725 30.225,76.725 Z M54,76.725 C51.9,76.725 50.25,75.075 50.25,72.975 C50.25,70.875 51.9,69.225 54,69.225 C56.1,69.225 57.75,70.875 57.75,72.975 C57.75,75.075 56.1,76.725 54,76.725 Z M77.85,76.725 C75.75,76.725 74.1,75.075 74.1,72.975 C74.1,70.875 75.75,69.225 77.85,69.225 C79.95,69.225 81.6,70.875 81.6,72.975 C81.6,75.075 79.95,76.725 77.85,76.725 Z M99,76.725 C96.9,76.725 95.25,75.075 95.25,72.975 C95.25,70.875 96.9,69.225 99,69.225 C101.1,69.225 102.75,70.875 102.75,72.975 C102.75,75.075 101.1,76.725 99,76.725 Z",
    id: "Shape",
    stroke: "#231F20",
    strokeWidth: 6,
    fill: "#231F20",
    fillRule: "nonzero",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102,0.675 L6,0.675 C2.7,0.675 0,3.375 0,6.675 L0,81.675 C0,84.375 1.725,86.625 4.125,87.375 C4.725,87.525 5.325,87.675 6,87.675 L102,87.675 C102.675,87.675 103.275,87.6 103.875,87.375 C106.275,86.625 108,84.375 108,81.675 L108,6.675 C108,3.375 105.375,0.675 102,0.675 Z M9,76.725 C6.9,76.725 5.25,75.075 5.25,72.975 C5.25,70.875 6.9,69.225 9,69.225 C11.1,69.225 12.75,70.875 12.75,72.975 C12.75,75.075 11.1,76.725 9,76.725 Z M30.225,76.725 C28.125,76.725 26.475,75.075 26.475,72.975 C26.475,70.875 28.125,69.225 30.225,69.225 C32.325,69.225 33.975,70.875 33.975,72.975 C33.975,75.075 32.25,76.725 30.225,76.725 Z M54,76.725 C51.9,76.725 50.25,75.075 50.25,72.975 C50.25,70.875 51.9,69.225 54,69.225 C56.1,69.225 57.75,70.875 57.75,72.975 C57.75,75.075 56.1,76.725 54,76.725 Z M77.85,76.725 C75.75,76.725 74.1,75.075 74.1,72.975 C74.1,70.875 75.75,69.225 77.85,69.225 C79.95,69.225 81.6,70.875 81.6,72.975 C81.6,75.075 79.95,76.725 77.85,76.725 Z M99,76.725 C96.9,76.725 95.25,75.075 95.25,72.975 C95.25,70.875 96.9,69.225 99,69.225 C101.1,69.225 102.75,70.875 102.75,72.975 C102.75,75.075 101.1,76.725 99,76.725 Z",
    id: "Shape",
    fill: "#414757",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,27.675 L0,6.675 C0,3.375 2.7,0.675 6,0.675 L27,0.675 L0,27.675 Z",
    id: "Shape",
    fill: "#4C97FF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Shape",
    fill: "#4C97FF",
    fillRule: "nonzero",
    points: "27 12.675 27 0.675 39 0.675"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Shape",
    fill: "#4C97FF",
    fillRule: "nonzero",
    points: "39 9.675 39 0.675 48 0.675"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Shape",
    stroke: "#4C97FF",
    strokeWidth: 0.75,
    fill: "#4C97FF",
    fillRule: "nonzero",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    points: "94.5 30.675 94.5 21.675 103.5 21.675"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Shape",
    stroke: "#4C97FF",
    strokeWidth: 0.75,
    fill: "#4C97FF",
    fillRule: "nonzero",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    points: "13.5 51.675 13.5 60.675 4.5 60.675"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3,42.675 C2.175,42.675 1.5,42 1.5,41.175 C1.5,40.35 2.175,39.675 3,39.675 C3.825,39.675 4.5,40.35 4.5,41.175 C4.5,42 3.825,42.675 3,42.675 Z",
    id: "Shape",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105,42.675 C104.175,42.675 103.5,42 103.5,41.175 C103.5,40.35 104.175,39.675 105,39.675 C105.825,39.675 106.5,40.35 106.5,41.175 C106.5,42 105.825,42.675 105,42.675 Z",
    id: "Shape",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(45.000000, 9.750000)",
    fill: "#4C97FF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.825,6.3 C13.425,6.3 13.875,5.85 13.875,5.25 C13.875,4.65 13.425,4.2 12.825,4.2 C12.225,4.2 11.775,4.65 11.775,5.25 C11.775,5.85 12.225,6.3 12.825,6.3",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.175,4.2 C4.575,4.2 4.125,4.65 4.125,5.25 C4.125,5.85 4.575,6.3 5.175,6.3 C5.775,6.3 6.225,5.85 6.225,5.25 C6.225,4.65 5.775,4.2 5.175,4.2",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.175,2.175 C3.45,2.175 2.1,3.525 2.1,5.25 C2.1,6.975 3.45,8.325 5.175,8.325 L12.9,8.325 C14.625,8.325 15.975,6.975 15.975,5.25 C15.975,3.525 14.625,2.175 12.9,2.175 L5.175,2.175 M12.9,10.425 L5.175,10.425 C2.325,10.425 0,8.1 0,5.25 C0,2.4 2.325,0.075 5.175,0.075 L12.9,0.075 C15.75,0.075 18.075,2.4 18.075,5.25 C18,8.1 15.75,10.425 12.9,10.425",
    id: "Shape"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(6.000000, 33.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.5,0.675 L1.5,0.675 C0.675,0.675 0,1.35 0,2.175 L0,14.175 C0,15 0.675,15.675 1.5,15.675 L13.5,15.675 C14.325,15.675 15,15 15,14.175 L15,2.175 C15,1.35 14.325,0.675 13.5,0.675 Z",
    id: "Shape",
    stroke: "#231F20",
    strokeWidth: 3,
    fill: "#231F20",
    opacity: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5,0.675 L1.5,0.675 C0.675,0.675 0,1.35 0,2.175 L0,14.175 C0,15 0.675,15.675 1.5,15.675 L13.5,15.675 C14.325,15.675 15,15 15,14.175 L15,2.175 C15,1.35 14.325,0.675 13.5,0.675 Z",
    id: "Shape",
    stroke: "#7C87A5",
    strokeWidth: 0.75,
    fill: "#E6E7E8",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    stroke: "#231F20",
    strokeWidth: 2.25,
    fill: "#231F20",
    opacity: 0.1,
    cx: 7.5,
    cy: 8.175,
    r: 3
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    stroke: "#414757",
    strokeWidth: 0.75,
    fill: "#414757",
    cx: 7.5,
    cy: 8.175,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(87.000000, 33.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.5,0.675 L1.5,0.675 C0.675,0.675 0,1.35 0,2.175 L0,14.175 C0,15 0.675,15.675 1.5,15.675 L13.5,15.675 C14.325,15.675 15,15 15,14.175 L15,2.175 C15,1.35 14.325,0.675 13.5,0.675 Z",
    id: "Shape",
    stroke: "#231F20",
    strokeWidth: 3,
    fill: "#231F20",
    opacity: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5,0.675 L1.5,0.675 C0.675,0.675 0,1.35 0,2.175 L0,14.175 C0,15 0.675,15.675 1.5,15.675 L13.5,15.675 C14.325,15.675 15,15 15,14.175 L15,2.175 C15,1.35 14.325,0.675 13.5,0.675 Z",
    id: "Shape",
    stroke: "#7C87A5",
    strokeWidth: 0.75,
    fill: "#E6E7E8",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    stroke: "#231F20",
    strokeWidth: 2.25,
    fill: "#231F20",
    opacity: 0.1,
    cx: 7.5,
    cy: 8.175,
    r: 3
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    stroke: "#414757",
    strokeWidth: 0.75,
    fill: "#414757",
    cx: 7.5,
    cy: 8.175,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(36.000000, 26.250000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Shape"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    fill: "#E6E7E8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.35,2.175 L0.15,2.175 C0.075,2.175 -7.10542736e-15,2.1 -7.10542736e-15,2.025 L-7.10542736e-15,0.825 C-7.10542736e-15,0.75 0.075,0.675 0.15,0.675 L1.35,0.675 C1.425,0.675 1.5,0.75 1.5,0.825 L1.5,2.025 C1.5,2.1 1.5,2.175 1.35,2.175 Z"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.25,
    transform: "translate(0.000000, 2.250000)",
    fill: "#231F20"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.35,2.175 L0.15,2.175 C0.075,2.175 -7.10542736e-15,2.1 -7.10542736e-15,2.025 L-7.10542736e-15,0.825 C-7.10542736e-15,0.75 0.075,0.675 0.15,0.675 L1.35,0.675 C1.425,0.675 1.5,0.75 1.5,0.825 L1.5,2.025 C1.5,2.1 1.5,2.175 1.35,2.175 Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1.35,3.675 L0.15,3.675 C0.075,3.675 -7.10542736e-15,3.6 -7.10542736e-15,3.525 L-7.10542736e-15,1.575 C-7.10542736e-15,1.5 0.075,1.425 0.15,1.425 L1.35,1.425 C1.425,1.425 1.5,1.5 1.5,1.575 L1.5,3.525 C1.5,3.6 1.5,3.675 1.35,3.675 Z",
    fill: "#E6E7E8"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(8.250000, 0.000000)",
    id: "Shape"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    fill: "#E6E7E8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.725,2.175 L0.525,2.175 C0.45,2.175 0.375,2.1 0.375,2.025 L0.375,0.825 C0.375,0.75 0.45,0.675 0.525,0.675 L1.725,0.675 C1.8,0.675 1.875,0.75 1.875,0.825 L1.875,2.025 C1.875,2.1 1.875,2.175 1.725,2.175 Z"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.25,
    transform: "translate(0.000000, 2.250000)",
    fill: "#231F20"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.725,2.175 L0.525,2.175 C0.45,2.175 0.375,2.1 0.375,2.025 L0.375,0.825 C0.375,0.75 0.45,0.675 0.525,0.675 L1.725,0.675 C1.8,0.675 1.875,0.75 1.875,0.825 L1.875,2.025 C1.875,2.1 1.875,2.175 1.725,2.175 Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1.725,3.675 L0.525,3.675 C0.45,3.675 0.375,3.6 0.375,3.525 L0.375,1.575 C0.375,1.5 0.45,1.425 0.525,1.425 L1.725,1.425 C1.8,1.425 1.875,1.5 1.875,1.575 L1.875,3.525 C1.875,3.6 1.875,3.675 1.725,3.675 Z",
    fill: "#E6E7E8"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(17.250000, 0.000000)",
    id: "Shape"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    fill: "#E6E7E8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.35,2.175 L0.15,2.175 C0.075,2.175 0,2.1 0,2.025 L0,0.825 C0,0.75 0.075,0.675 0.15,0.675 L1.35,0.675 C1.425,0.675 1.5,0.75 1.5,0.825 L1.5,2.025 C1.5,2.1 1.5,2.175 1.35,2.175 Z"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.25,
    transform: "translate(0.000000, 2.250000)",
    fill: "#231F20"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.35,2.175 L0.15,2.175 C0.075,2.175 0,2.1 0,2.025 L0,0.825 C0,0.75 0.075,0.675 0.15,0.675 L1.35,0.675 C1.425,0.675 1.5,0.75 1.5,0.825 L1.5,2.025 C1.5,2.1 1.5,2.175 1.35,2.175 Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1.35,3.675 L0.15,3.675 C0.075,3.675 0,3.6 0,3.525 L0,1.575 C0,1.5 0.075,1.425 0.15,1.425 L1.35,1.425 C1.425,1.425 1.5,1.5 1.5,1.575 L1.5,3.525 C1.5,3.6 1.5,3.675 1.35,3.675 Z",
    fill: "#E6E7E8"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(25.500000, 0.000000)",
    id: "Shape"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    fill: "#E6E7E8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.725,2.175 L0.525,2.175 C0.45,2.175 0.375,2.1 0.375,2.025 L0.375,0.825 C0.375,0.75 0.45,0.675 0.525,0.675 L1.725,0.675 C1.8,0.675 1.875,0.75 1.875,0.825 L1.875,2.025 C1.875,2.1 1.875,2.175 1.725,2.175 Z"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.25,
    transform: "translate(0.000000, 2.250000)",
    fill: "#231F20"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.725,2.175 L0.525,2.175 C0.45,2.175 0.375,2.1 0.375,2.025 L0.375,0.825 C0.375,0.75 0.45,0.675 0.525,0.675 L1.725,0.675 C1.8,0.675 1.875,0.75 1.875,0.825 L1.875,2.025 C1.875,2.1 1.875,2.175 1.725,2.175 Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1.725,3.675 L0.525,3.675 C0.45,3.675 0.375,3.6 0.375,3.525 L0.375,1.575 C0.375,1.5 0.45,1.425 0.525,1.425 L1.725,1.425 C1.8,1.425 1.875,1.5 1.875,1.575 L1.875,3.525 C1.875,3.6 1.875,3.675 1.725,3.675 Z",
    fill: "#E6E7E8"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(34.500000, 0.000000)",
    id: "Shape"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    fill: "#E6E7E8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.35,2.175 L0.15,2.175 C0.075,2.175 0,2.1 0,2.025 L0,0.825 C0,0.75 0.075,0.675 0.15,0.675 L1.35,0.675 C1.425,0.675 1.5,0.75 1.5,0.825 L1.5,2.025 C1.5,2.1 1.5,2.175 1.35,2.175 Z"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.25,
    transform: "translate(0.000000, 2.250000)",
    fill: "#231F20"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.35,2.175 L0.15,2.175 C0.075,2.175 0,2.1 0,2.025 L0,0.825 C0,0.75 0.075,0.675 0.15,0.675 L1.35,0.675 C1.425,0.675 1.5,0.75 1.5,0.825 L1.5,2.025 C1.5,2.1 1.5,2.175 1.35,2.175 Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1.35,3.675 L0.15,3.675 C0.075,3.675 0,3.6 0,3.525 L0,1.575 C0,1.5 0.075,1.425 0.15,1.425 L1.35,1.425 C1.425,1.425 1.5,1.5 1.5,1.575 L1.5,3.525 C1.5,3.6 1.5,3.675 1.35,3.675 Z",
    fill: "#E6E7E8"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(36.000000, 35.250000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Shape"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    fill: "#E6E7E8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.35,1.575 L0.15,1.575 C0.075,1.575 -7.10542736e-15,1.5 -7.10542736e-15,1.425 L-7.10542736e-15,0.225 C-7.10542736e-15,0.15 0.075,0.075 0.15,0.075 L1.35,0.075 C1.425,0.075 1.5,0.15 1.5,0.225 L1.5,1.425 C1.5,1.5 1.5,1.575 1.35,1.575 Z"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.25,
    transform: "translate(0.000000, 2.250000)",
    fill: "#231F20"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.35,1.575 L0.15,1.575 C0.075,1.575 -7.10542736e-15,1.5 -7.10542736e-15,1.425 L-7.10542736e-15,0.225 C-7.10542736e-15,0.15 0.075,0.075 0.15,0.075 L1.35,0.075 C1.425,0.075 1.5,0.15 1.5,0.225 L1.5,1.425 C1.5,1.5 1.5,1.575 1.35,1.575 Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1.35,3.075 L0.15,3.075 C0.075,3.075 -7.10542736e-15,3 -7.10542736e-15,2.925 L-7.10542736e-15,0.975 C-7.10542736e-15,0.9 0.075,0.825 0.15,0.825 L1.35,0.825 C1.425,0.825 1.5,0.9 1.5,0.975 L1.5,2.925 C1.5,3 1.5,3.075 1.35,3.075 Z",
    fill: "#E6E7E8"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(8.250000, 0.000000)",
    id: "Shape"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    fill: "#E6E7E8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.725,1.575 L0.525,1.575 C0.45,1.575 0.375,1.5 0.375,1.425 L0.375,0.225 C0.375,0.15 0.45,0.075 0.525,0.075 L1.725,0.075 C1.8,0.075 1.875,0.15 1.875,0.225 L1.875,1.425 C1.875,1.5 1.875,1.575 1.725,1.575 Z"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.25,
    transform: "translate(0.000000, 2.250000)",
    fill: "#231F20"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.725,1.575 L0.525,1.575 C0.45,1.575 0.375,1.5 0.375,1.425 L0.375,0.225 C0.375,0.15 0.45,0.075 0.525,0.075 L1.725,0.075 C1.8,0.075 1.875,0.15 1.875,0.225 L1.875,1.425 C1.875,1.5 1.875,1.575 1.725,1.575 Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1.725,3.075 L0.525,3.075 C0.45,3.075 0.375,3 0.375,2.925 L0.375,0.975 C0.375,0.9 0.45,0.825 0.525,0.825 L1.725,0.825 C1.8,0.825 1.875,0.9 1.875,0.975 L1.875,2.925 C1.875,3 1.875,3.075 1.725,3.075 Z",
    fill: "#E6E7E8"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(17.250000, 0.000000)",
    id: "Shape"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    fill: "#E6E7E8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.35,1.575 L0.15,1.575 C0.075,1.575 0,1.5 0,1.425 L0,0.225 C0,0.15 0.075,0.075 0.15,0.075 L1.35,0.075 C1.425,0.075 1.5,0.15 1.5,0.225 L1.5,1.425 C1.5,1.5 1.5,1.575 1.35,1.575 Z"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.25,
    transform: "translate(0.000000, 2.250000)",
    fill: "#231F20"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.35,1.575 L0.15,1.575 C0.075,1.575 0,1.5 0,1.425 L0,0.225 C0,0.15 0.075,0.075 0.15,0.075 L1.35,0.075 C1.425,0.075 1.5,0.15 1.5,0.225 L1.5,1.425 C1.5,1.5 1.5,1.575 1.35,1.575 Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1.35,3.075 L0.15,3.075 C0.075,3.075 0,3 0,2.925 L0,0.975 C0,0.9 0.075,0.825 0.15,0.825 L1.35,0.825 C1.425,0.825 1.5,0.9 1.5,0.975 L1.5,2.925 C1.5,3 1.5,3.075 1.35,3.075 Z",
    fill: "#E6E7E8"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(25.500000, 0.000000)",
    id: "Shape"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    fill: "#E6E7E8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.725,1.575 L0.525,1.575 C0.45,1.575 0.375,1.5 0.375,1.425 L0.375,0.225 C0.375,0.15 0.45,0.075 0.525,0.075 L1.725,0.075 C1.8,0.075 1.875,0.15 1.875,0.225 L1.875,1.425 C1.875,1.5 1.875,1.575 1.725,1.575 Z"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.25,
    transform: "translate(0.000000, 2.250000)",
    fill: "#231F20"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.725,1.575 L0.525,1.575 C0.45,1.575 0.375,1.5 0.375,1.425 L0.375,0.225 C0.375,0.15 0.45,0.075 0.525,0.075 L1.725,0.075 C1.8,0.075 1.875,0.15 1.875,0.225 L1.875,1.425 C1.875,1.5 1.875,1.575 1.725,1.575 Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1.725,3.075 L0.525,3.075 C0.45,3.075 0.375,3 0.375,2.925 L0.375,0.975 C0.375,0.9 0.45,0.825 0.525,0.825 L1.725,0.825 C1.8,0.825 1.875,0.9 1.875,0.975 L1.875,2.925 C1.875,3 1.875,3.075 1.725,3.075 Z",
    fill: "#E6E7E8"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(34.500000, 0.000000)",
    id: "Shape"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    fill: "#E6E7E8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.35,1.575 L0.15,1.575 C0.075,1.575 0,1.5 0,1.425 L0,0.225 C0,0.15 0.075,0.075 0.15,0.075 L1.35,0.075 C1.425,0.075 1.5,0.15 1.5,0.225 L1.5,1.425 C1.5,1.5 1.5,1.575 1.35,1.575 Z"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.25,
    transform: "translate(0.000000, 2.250000)",
    fill: "#231F20"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.35,1.575 L0.15,1.575 C0.075,1.575 0,1.5 0,1.425 L0,0.225 C0,0.15 0.075,0.075 0.15,0.075 L1.35,0.075 C1.425,0.075 1.5,0.15 1.5,0.225 L1.5,1.425 C1.5,1.5 1.5,1.575 1.35,1.575 Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1.35,3.075 L0.15,3.075 C0.075,3.075 0,3 0,2.925 L0,0.975 C0,0.9 0.075,0.825 0.15,0.825 L1.35,0.825 C1.425,0.825 1.5,0.9 1.5,0.975 L1.5,2.925 C1.5,3 1.5,3.075 1.35,3.075 Z",
    fill: "#E6E7E8"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(36.000000, 43.500000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Shape"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    fill: "#E6E7E8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.35,1.8 L0.15,1.8 C0.075,1.8 -7.10542736e-15,1.725 -7.10542736e-15,1.65 L-7.10542736e-15,0.45 C-7.10542736e-15,0.375 0.075,0.3 0.15,0.3 L1.35,0.3 C1.425,0.3 1.5,0.375 1.5,0.45 L1.5,1.65 C1.5,1.725 1.5,1.8 1.35,1.8 Z"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.25,
    transform: "translate(0.000000, 2.250000)",
    fill: "#231F20"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.35,1.8 L0.15,1.8 C0.075,1.8 -7.10542736e-15,1.725 -7.10542736e-15,1.65 L-7.10542736e-15,0.45 C-7.10542736e-15,0.375 0.075,0.3 0.15,0.3 L1.35,0.3 C1.425,0.3 1.5,0.375 1.5,0.45 L1.5,1.65 C1.5,1.725 1.5,1.8 1.35,1.8 Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1.35,3.3 L0.15,3.3 C0.075,3.3 -7.10542736e-15,3.225 -7.10542736e-15,3.15 L-7.10542736e-15,1.2 C-7.10542736e-15,1.125 0.075,1.05 0.15,1.05 L1.35,1.05 C1.425,1.05 1.5,1.125 1.5,1.2 L1.5,3.15 C1.5,3.225 1.5,3.3 1.35,3.3 Z",
    fill: "#E6E7E8"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(8.250000, 0.000000)",
    id: "Shape"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    fill: "#E6E7E8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.725,1.8 L0.525,1.8 C0.45,1.8 0.375,1.725 0.375,1.65 L0.375,0.45 C0.375,0.375 0.45,0.3 0.525,0.3 L1.725,0.3 C1.8,0.3 1.875,0.375 1.875,0.45 L1.875,1.65 C1.875,1.725 1.875,1.8 1.725,1.8 Z"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.25,
    transform: "translate(0.000000, 2.250000)",
    fill: "#231F20"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.725,1.8 L0.525,1.8 C0.45,1.8 0.375,1.725 0.375,1.65 L0.375,0.45 C0.375,0.375 0.45,0.3 0.525,0.3 L1.725,0.3 C1.8,0.3 1.875,0.375 1.875,0.45 L1.875,1.65 C1.875,1.725 1.875,1.8 1.725,1.8 Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1.725,3.3 L0.525,3.3 C0.45,3.3 0.375,3.225 0.375,3.15 L0.375,1.2 C0.375,1.125 0.45,1.05 0.525,1.05 L1.725,1.05 C1.8,1.05 1.875,1.125 1.875,1.2 L1.875,3.15 C1.875,3.225 1.875,3.3 1.725,3.3 Z",
    fill: "#E6E7E8"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(17.250000, 0.000000)",
    id: "Shape"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    fill: "#E6E7E8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.35,1.8 L0.15,1.8 C0.075,1.8 0,1.725 0,1.65 L0,0.45 C0,0.375 0.075,0.3 0.15,0.3 L1.35,0.3 C1.425,0.3 1.5,0.375 1.5,0.45 L1.5,1.65 C1.5,1.725 1.5,1.8 1.35,1.8 Z"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.25,
    transform: "translate(0.000000, 2.250000)",
    fill: "#231F20"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.35,1.8 L0.15,1.8 C0.075,1.8 0,1.725 0,1.65 L0,0.45 C0,0.375 0.075,0.3 0.15,0.3 L1.35,0.3 C1.425,0.3 1.5,0.375 1.5,0.45 L1.5,1.65 C1.5,1.725 1.5,1.8 1.35,1.8 Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1.35,3.3 L0.15,3.3 C0.075,3.3 0,3.225 0,3.15 L0,1.2 C0,1.125 0.075,1.05 0.15,1.05 L1.35,1.05 C1.425,1.05 1.5,1.125 1.5,1.2 L1.5,3.15 C1.5,3.225 1.5,3.3 1.35,3.3 Z",
    fill: "#E6E7E8"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(25.500000, 0.000000)",
    id: "Shape"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    fill: "#E6E7E8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.725,1.8 L0.525,1.8 C0.45,1.8 0.375,1.725 0.375,1.65 L0.375,0.45 C0.375,0.375 0.45,0.3 0.525,0.3 L1.725,0.3 C1.8,0.3 1.875,0.375 1.875,0.45 L1.875,1.65 C1.875,1.725 1.875,1.8 1.725,1.8 Z"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.25,
    transform: "translate(0.000000, 2.250000)",
    fill: "#231F20"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.725,1.8 L0.525,1.8 C0.45,1.8 0.375,1.725 0.375,1.65 L0.375,0.45 C0.375,0.375 0.45,0.3 0.525,0.3 L1.725,0.3 C1.8,0.3 1.875,0.375 1.875,0.45 L1.875,1.65 C1.875,1.725 1.875,1.8 1.725,1.8 Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1.725,3.3 L0.525,3.3 C0.45,3.3 0.375,3.225 0.375,3.15 L0.375,1.2 C0.375,1.125 0.45,1.05 0.525,1.05 L1.725,1.05 C1.8,1.05 1.875,1.125 1.875,1.2 L1.875,3.15 C1.875,3.225 1.875,3.3 1.725,3.3 Z",
    fill: "#E6E7E8"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(34.500000, 0.000000)",
    id: "Shape"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    fill: "#E6E7E8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.35,1.8 L0.15,1.8 C0.075,1.8 0,1.725 0,1.65 L0,0.45 C0,0.375 0.075,0.3 0.15,0.3 L1.35,0.3 C1.425,0.3 1.5,0.375 1.5,0.45 L1.5,1.65 C1.5,1.725 1.5,1.8 1.35,1.8 Z"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.25,
    transform: "translate(0.000000, 2.250000)",
    fill: "#231F20"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.35,1.8 L0.15,1.8 C0.075,1.8 0,1.725 0,1.65 L0,0.45 C0,0.375 0.075,0.3 0.15,0.3 L1.35,0.3 C1.425,0.3 1.5,0.375 1.5,0.45 L1.5,1.65 C1.5,1.725 1.5,1.8 1.35,1.8 Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1.35,3.3 L0.15,3.3 C0.075,3.3 0,3.225 0,3.15 L0,1.2 C0,1.125 0.075,1.05 0.15,1.05 L1.35,1.05 C1.425,1.05 1.5,1.125 1.5,1.2 L1.5,3.15 C1.5,3.225 1.5,3.3 1.35,3.3 Z",
    fill: "#E6E7E8"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(36.000000, 51.750000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Shape"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    fill: "#E6E7E8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.35,1.95 L0.15,1.95 C0.075,1.95 -7.10542736e-15,1.875 -7.10542736e-15,1.8 L-7.10542736e-15,0.6 C-7.10542736e-15,0.525 0.075,0.45 0.15,0.45 L1.35,0.45 C1.425,0.45 1.5,0.525 1.5,0.6 L1.5,1.8 C1.5,1.875 1.5,1.95 1.35,1.95 Z"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.25,
    transform: "translate(0.000000, 2.250000)",
    fill: "#231F20"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.35,1.95 L0.15,1.95 C0.075,1.95 -7.10542736e-15,1.875 -7.10542736e-15,1.8 L-7.10542736e-15,0.6 C-7.10542736e-15,0.525 0.075,0.45 0.15,0.45 L1.35,0.45 C1.425,0.45 1.5,0.525 1.5,0.6 L1.5,1.8 C1.5,1.875 1.5,1.95 1.35,1.95 Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1.35,3.45 L0.15,3.45 C0.075,3.45 -7.10542736e-15,3.375 -7.10542736e-15,3.3 L-7.10542736e-15,1.35 C-7.10542736e-15,1.275 0.075,1.2 0.15,1.2 L1.35,1.2 C1.425,1.2 1.5,1.275 1.5,1.35 L1.5,3.3 C1.5,3.375 1.5,3.45 1.35,3.45 Z",
    fill: "#E6E7E8"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(8.250000, 0.000000)",
    id: "Shape"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    fill: "#E6E7E8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.725,1.95 L0.525,1.95 C0.45,1.95 0.375,1.875 0.375,1.8 L0.375,0.6 C0.375,0.525 0.45,0.45 0.525,0.45 L1.725,0.45 C1.8,0.45 1.875,0.525 1.875,0.6 L1.875,1.8 C1.875,1.875 1.875,1.95 1.725,1.95 Z"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.25,
    transform: "translate(0.000000, 2.250000)",
    fill: "#231F20"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.725,1.95 L0.525,1.95 C0.45,1.95 0.375,1.875 0.375,1.8 L0.375,0.6 C0.375,0.525 0.45,0.45 0.525,0.45 L1.725,0.45 C1.8,0.45 1.875,0.525 1.875,0.6 L1.875,1.8 C1.875,1.875 1.875,1.95 1.725,1.95 Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1.725,3.45 L0.525,3.45 C0.45,3.45 0.375,3.375 0.375,3.3 L0.375,1.35 C0.375,1.275 0.45,1.2 0.525,1.2 L1.725,1.2 C1.8,1.2 1.875,1.275 1.875,1.35 L1.875,3.3 C1.875,3.375 1.875,3.45 1.725,3.45 Z",
    fill: "#E6E7E8"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(17.250000, 0.000000)",
    id: "Shape"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    fill: "#E6E7E8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.35,1.95 L0.15,1.95 C0.075,1.95 0,1.875 0,1.8 L0,0.6 C0,0.525 0.075,0.45 0.15,0.45 L1.35,0.45 C1.425,0.45 1.5,0.525 1.5,0.6 L1.5,1.8 C1.5,1.875 1.5,1.95 1.35,1.95 Z"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.25,
    transform: "translate(0.000000, 2.250000)",
    fill: "#231F20"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.35,1.95 L0.15,1.95 C0.075,1.95 0,1.875 0,1.8 L0,0.6 C0,0.525 0.075,0.45 0.15,0.45 L1.35,0.45 C1.425,0.45 1.5,0.525 1.5,0.6 L1.5,1.8 C1.5,1.875 1.5,1.95 1.35,1.95 Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1.35,3.45 L0.15,3.45 C0.075,3.45 0,3.375 0,3.3 L0,1.35 C0,1.275 0.075,1.2 0.15,1.2 L1.35,1.2 C1.425,1.2 1.5,1.275 1.5,1.35 L1.5,3.3 C1.5,3.375 1.5,3.45 1.35,3.45 Z",
    fill: "#E6E7E8"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(25.500000, 0.000000)",
    id: "Shape"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    fill: "#E6E7E8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.725,1.95 L0.525,1.95 C0.45,1.95 0.375,1.875 0.375,1.8 L0.375,0.6 C0.375,0.525 0.45,0.45 0.525,0.45 L1.725,0.45 C1.8,0.45 1.875,0.525 1.875,0.6 L1.875,1.8 C1.875,1.875 1.875,1.95 1.725,1.95 Z"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.25,
    transform: "translate(0.000000, 2.250000)",
    fill: "#231F20"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.725,1.95 L0.525,1.95 C0.45,1.95 0.375,1.875 0.375,1.8 L0.375,0.6 C0.375,0.525 0.45,0.45 0.525,0.45 L1.725,0.45 C1.8,0.45 1.875,0.525 1.875,0.6 L1.875,1.8 C1.875,1.875 1.875,1.95 1.725,1.95 Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1.725,3.45 L0.525,3.45 C0.45,3.45 0.375,3.375 0.375,3.3 L0.375,1.35 C0.375,1.275 0.45,1.2 0.525,1.2 L1.725,1.2 C1.8,1.2 1.875,1.275 1.875,1.35 L1.875,3.3 C1.875,3.375 1.875,3.45 1.725,3.45 Z",
    fill: "#E6E7E8"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(34.500000, 0.000000)",
    id: "Shape"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    fill: "#E6E7E8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.35,1.95 L0.15,1.95 C0.075,1.95 0,1.875 0,1.8 L0,0.6 C0,0.525 0.075,0.45 0.15,0.45 L1.35,0.45 C1.425,0.45 1.5,0.525 1.5,0.6 L1.5,1.8 C1.5,1.875 1.5,1.95 1.35,1.95 Z"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.25,
    transform: "translate(0.000000, 2.250000)",
    fill: "#231F20"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.35,1.95 L0.15,1.95 C0.075,1.95 0,1.875 0,1.8 L0,0.6 C0,0.525 0.075,0.45 0.15,0.45 L1.35,0.45 C1.425,0.45 1.5,0.525 1.5,0.6 L1.5,1.8 C1.5,1.875 1.5,1.95 1.35,1.95 Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1.35,3.45 L0.15,3.45 C0.075,3.45 0,3.375 0,3.3 L0,1.35 C0,1.275 0.075,1.2 0.15,1.2 L1.35,1.2 C1.425,1.2 1.5,1.275 1.5,1.35 L1.5,3.3 C1.5,3.375 1.5,3.45 1.35,3.45 Z",
    fill: "#E6E7E8"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(36.000000, 60.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Shape"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    fill: "#E6E7E8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.35,2.175 L0.15,2.175 C0.075,2.175 -7.10542736e-15,2.1 -7.10542736e-15,2.025 L-7.10542736e-15,0.825 C-7.10542736e-15,0.75 0.075,0.675 0.15,0.675 L1.35,0.675 C1.425,0.675 1.5,0.75 1.5,0.825 L1.5,2.025 C1.5,2.1 1.5,2.175 1.35,2.175 Z"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.25,
    transform: "translate(0.000000, 2.250000)",
    fill: "#231F20"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.35,2.175 L0.15,2.175 C0.075,2.175 -7.10542736e-15,2.1 -7.10542736e-15,2.025 L-7.10542736e-15,0.825 C-7.10542736e-15,0.75 0.075,0.675 0.15,0.675 L1.35,0.675 C1.425,0.675 1.5,0.75 1.5,0.825 L1.5,2.025 C1.5,2.1 1.5,2.175 1.35,2.175 Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1.35,3.675 L0.15,3.675 C0.075,3.675 -7.10542736e-15,3.6 -7.10542736e-15,3.525 L-7.10542736e-15,1.575 C-7.10542736e-15,1.5 0.075,1.425 0.15,1.425 L1.35,1.425 C1.425,1.425 1.5,1.5 1.5,1.575 L1.5,3.525 C1.5,3.6 1.5,3.675 1.35,3.675 Z",
    fill: "#E6E7E8"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(8.250000, 0.000000)",
    id: "Shape"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    fill: "#E6E7E8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.725,2.175 L0.525,2.175 C0.45,2.175 0.375,2.1 0.375,2.025 L0.375,0.825 C0.375,0.75 0.45,0.675 0.525,0.675 L1.725,0.675 C1.8,0.675 1.875,0.75 1.875,0.825 L1.875,2.025 C1.875,2.1 1.875,2.175 1.725,2.175 Z"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.25,
    transform: "translate(0.000000, 2.250000)",
    fill: "#231F20"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.725,2.175 L0.525,2.175 C0.45,2.175 0.375,2.1 0.375,2.025 L0.375,0.825 C0.375,0.75 0.45,0.675 0.525,0.675 L1.725,0.675 C1.8,0.675 1.875,0.75 1.875,0.825 L1.875,2.025 C1.875,2.1 1.875,2.175 1.725,2.175 Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1.725,3.675 L0.525,3.675 C0.45,3.675 0.375,3.6 0.375,3.525 L0.375,1.575 C0.375,1.5 0.45,1.425 0.525,1.425 L1.725,1.425 C1.8,1.425 1.875,1.5 1.875,1.575 L1.875,3.525 C1.875,3.6 1.875,3.675 1.725,3.675 Z",
    fill: "#E6E7E8"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(17.250000, 0.000000)",
    id: "Shape"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    fill: "#E6E7E8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.35,2.175 L0.15,2.175 C0.075,2.175 0,2.1 0,2.025 L0,0.825 C0,0.75 0.075,0.675 0.15,0.675 L1.35,0.675 C1.425,0.675 1.5,0.75 1.5,0.825 L1.5,2.025 C1.5,2.1 1.5,2.175 1.35,2.175 Z"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.25,
    transform: "translate(0.000000, 2.250000)",
    fill: "#231F20"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.35,2.175 L0.15,2.175 C0.075,2.175 0,2.1 0,2.025 L0,0.825 C0,0.75 0.075,0.675 0.15,0.675 L1.35,0.675 C1.425,0.675 1.5,0.75 1.5,0.825 L1.5,2.025 C1.5,2.1 1.5,2.175 1.35,2.175 Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1.35,3.675 L0.15,3.675 C0.075,3.675 0,3.6 0,3.525 L0,1.575 C0,1.5 0.075,1.425 0.15,1.425 L1.35,1.425 C1.425,1.425 1.5,1.5 1.5,1.575 L1.5,3.525 C1.5,3.6 1.5,3.675 1.35,3.675 Z",
    fill: "#E6E7E8"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(25.500000, 0.000000)",
    id: "Shape"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    fill: "#E6E7E8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.725,2.175 L0.525,2.175 C0.45,2.175 0.375,2.1 0.375,2.025 L0.375,0.825 C0.375,0.75 0.45,0.675 0.525,0.675 L1.725,0.675 C1.8,0.675 1.875,0.75 1.875,0.825 L1.875,2.025 C1.875,2.1 1.875,2.175 1.725,2.175 Z"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.25,
    transform: "translate(0.000000, 2.250000)",
    fill: "#231F20"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.725,2.175 L0.525,2.175 C0.45,2.175 0.375,2.1 0.375,2.025 L0.375,0.825 C0.375,0.75 0.45,0.675 0.525,0.675 L1.725,0.675 C1.8,0.675 1.875,0.75 1.875,0.825 L1.875,2.025 C1.875,2.1 1.875,2.175 1.725,2.175 Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1.725,3.675 L0.525,3.675 C0.45,3.675 0.375,3.6 0.375,3.525 L0.375,1.575 C0.375,1.5 0.45,1.425 0.525,1.425 L1.725,1.425 C1.8,1.425 1.875,1.5 1.875,1.575 L1.875,3.525 C1.875,3.6 1.875,3.675 1.725,3.675 Z",
    fill: "#E6E7E8"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(34.500000, 0.000000)",
    id: "Shape"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    fill: "#E6E7E8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.35,2.175 L0.15,2.175 C0.075,2.175 0,2.1 0,2.025 L0,0.825 C0,0.75 0.075,0.675 0.15,0.675 L1.35,0.675 C1.425,0.675 1.5,0.75 1.5,0.825 L1.5,2.025 C1.5,2.1 1.5,2.175 1.35,2.175 Z"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.25,
    transform: "translate(0.000000, 2.250000)",
    fill: "#231F20"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.35,2.175 L0.15,2.175 C0.075,2.175 0,2.1 0,2.025 L0,0.825 C0,0.75 0.075,0.675 0.15,0.675 L1.35,0.675 C1.425,0.675 1.5,0.75 1.5,0.825 L1.5,2.025 C1.5,2.1 1.5,2.175 1.35,2.175 Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1.35,3.675 L0.15,3.675 C0.075,3.675 0,3.6 0,3.525 L0,1.575 C0,1.5 0.075,1.425 0.15,1.425 L1.35,1.425 C1.425,1.425 1.5,1.5 1.5,1.575 L1.5,3.525 C1.5,3.6 1.5,3.675 1.35,3.675 Z",
    fill: "#E6E7E8"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(1.500000, 76.500000)",
    fill: "#FFBF00",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.8,0.675 L1.8,10.5 C1.125,10.125 0.525,9.675 0.075,9.15 L0.075,0.675 L1.8,0.675 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Shape",
    points: "4.05 11.1 4.425 11.1 4.425 0.675 2.7 0.675 2.7 10.875"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-path",
    x: 5.325,
    y: 0.675,
    width: 1.8,
    height: 10.425
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-path",
    x: 7.95,
    y: 0.675,
    width: 1.8,
    height: 10.425
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-path",
    x: 10.65,
    y: 0.675,
    width: 1.8,
    height: 10.425
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-path",
    x: 13.275,
    y: 0.675,
    width: 1.8,
    height: 10.425
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-path",
    x: 15.9,
    y: 0.675,
    width: 1.8,
    height: 10.425
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-path",
    x: 18.525,
    y: 0.675,
    width: 1.8,
    height: 10.425
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-path",
    x: 21.225,
    y: 0.675,
    width: 1.8,
    height: 10.425
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-path",
    x: 23.85,
    y: 0.675,
    width: 1.8,
    height: 10.425
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-path",
    x: 26.475,
    y: 0.675,
    width: 1.8,
    height: 10.425
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-path",
    x: 29.175,
    y: 0.675,
    width: 1.8,
    height: 10.425
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-path",
    x: 31.8,
    y: 0.675,
    width: 1.8,
    height: 10.425
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-path",
    x: 34.425,
    y: 0.675,
    width: 1.8,
    height: 10.425
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-path",
    x: 37.125,
    y: 0.675,
    width: 1.8,
    height: 10.425
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-path",
    x: 39.75,
    y: 0.675,
    width: 1.8,
    height: 10.425
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-path",
    x: 42.375,
    y: 0.675,
    width: 1.8,
    height: 10.425
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-path",
    x: 45,
    y: 0.675,
    width: 1.8,
    height: 10.425
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-path",
    x: 47.7,
    y: 0.675,
    width: 1.8,
    height: 10.425
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-path",
    x: 50.325,
    y: 0.675,
    width: 1.8,
    height: 10.425
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-path",
    x: 52.95,
    y: 0.675,
    width: 1.8,
    height: 10.425
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-path",
    x: 55.65,
    y: 0.675,
    width: 1.8,
    height: 10.425
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-path",
    x: 58.275,
    y: 0.675,
    width: 1.8,
    height: 10.425
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-path",
    x: 60.9,
    y: 0.675,
    width: 1.8,
    height: 10.425
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-path",
    x: 63.525,
    y: 0.675,
    width: 1.8,
    height: 10.425
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-path",
    x: 66.225,
    y: 0.675,
    width: 1.8,
    height: 10.425
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-path",
    x: 68.85,
    y: 0.675,
    width: 1.8,
    height: 10.425
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-path",
    x: 71.475,
    y: 0.675,
    width: 1.8,
    height: 10.425
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-path",
    x: 74.175,
    y: 0.675,
    width: 1.8,
    height: 10.425
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-path",
    x: 76.8,
    y: 0.675,
    width: 1.8,
    height: 10.425
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-path",
    x: 79.425,
    y: 0.675,
    width: 1.8,
    height: 10.425
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-path",
    x: 82.125,
    y: 0.675,
    width: 1.8,
    height: 10.425
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-path",
    x: 84.75,
    y: 0.675,
    width: 1.8,
    height: 10.425
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-path",
    x: 87.375,
    y: 0.675,
    width: 1.8,
    height: 10.425
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-path",
    x: 90,
    y: 0.675,
    width: 1.8,
    height: 10.425
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-path",
    x: 92.7,
    y: 0.675,
    width: 1.8,
    height: 10.425
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-path",
    x: 95.325,
    y: 0.675,
    width: 1.8,
    height: 10.425
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-path",
    x: 97.95,
    y: 0.675,
    width: 1.8,
    height: 10.425
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Shape",
    points: "101.025 11.1 100.65 11.1 100.65 0.675 102.375 0.675 102.375 10.875"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105,0.675 L105,9.15 C104.475,9.75 103.95,10.2 103.275,10.5 L103.275,0.675 L105,0.675 Z",
    id: "Shape"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(3.750000, 67.500000)",
    fill: "#FFBF00",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.25,9.225 C3.15,9.225 1.5,7.575 1.5,5.475 C1.5,3.375 3.15,1.725 5.25,1.725 C7.35,1.725 9,3.375 9,5.475 C9,7.575 7.35,9.225 5.25,9.225 Z M2.25,20.175 L10.125,20.175 L10.125,5.55 C10.125,4.2 9.6,3 8.7,2.1 C7.8,1.2 6.6,0.675 5.25,0.675 C2.55,0.675 0.375,2.85 0.375,5.55 L0.375,19.875 L2.25,20.175 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.925,2.1 C29.025,1.2 27.825,0.675 26.475,0.675 C23.775,0.675 21.6,2.85 21.6,5.55 L21.6,20.175 L31.275,20.175 L31.275,5.55 C31.35,4.2 30.75,2.925 29.925,2.1 Z M26.475,9.225 C24.375,9.225 22.725,7.575 22.725,5.475 C22.725,3.375 24.375,1.725 26.475,1.725 C28.575,1.725 30.225,3.375 30.225,5.475 C30.225,7.575 28.5,9.225 26.475,9.225 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.7,2.1 C52.8,1.2 51.6,0.675 50.25,0.675 C47.55,0.675 45.375,2.85 45.375,5.55 L45.375,20.175 L55.05,20.175 L55.05,5.55 C55.125,4.2 54.6,2.925 53.7,2.1 Z M50.25,9.225 C48.15,9.225 46.5,7.575 46.5,5.475 C46.5,3.375 48.15,1.725 50.25,1.725 C52.35,1.725 54,3.375 54,5.475 C54,7.575 52.35,9.225 50.25,9.225 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.55,2.1 C76.65,1.2 75.45,0.675 74.1,0.675 C71.4,0.675 69.225,2.85 69.225,5.55 L69.225,20.175 L78.9,20.175 L78.9,5.55 C78.975,4.2 78.45,2.925 77.55,2.1 Z M74.1,9.225 C72,9.225 70.35,7.575 70.35,5.475 C70.35,3.375 72,1.725 74.1,1.725 C76.2,1.725 77.85,3.375 77.85,5.475 C77.85,7.575 76.2,9.225 74.1,9.225 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.7,2.1 C97.8,1.2 96.6,0.675 95.25,0.675 C92.55,0.675 90.375,2.85 90.375,5.55 L90.375,20.175 L98.25,20.175 L100.125,19.875 L100.125,5.55 C100.125,4.2 99.6,2.925 98.7,2.1 Z M95.25,9.225 C93.15,9.225 91.5,7.575 91.5,5.475 C91.5,3.375 93.15,1.725 95.25,1.725 C97.35,1.725 99,3.375 99,5.475 C99,7.575 97.35,9.225 95.25,9.225 Z",
    id: "Shape"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M9.0064043,80.0370297 C9.34576146,80.0370297 9.59112034,80.1767988 9.74248828,80.4563412 C9.85967637,80.6724067 9.91826953,80.9684243 9.91826953,81.3444027 C9.91826953,81.7008498 9.86516948,81.9956467 9.75896777,82.2288021 C9.60515841,82.5632765 9.35369608,82.7305111 9.00457324,82.7305111 C8.68963026,82.7305111 8.4552576,82.5937937 8.30144824,82.3203549 C8.17327377,82.0920823 8.1091875,81.7856888 8.1091875,81.4011654 C8.1091875,81.1033124 8.14763926,80.8475776 8.22454395,80.6339535 C8.36858763,80.2360023 8.62920515,80.0370297 9.0064043,80.0370297 Z M9.00274219,82.4302182 C9.17364148,82.4302182 9.30974852,82.3545353 9.41106738,82.2031674 C9.51238625,82.0517994 9.56304492,81.7698198 9.56304492,81.3572201 C9.56304492,81.0593671 9.52642419,80.8143134 9.45318164,80.6220517 C9.37993909,80.42979 9.23772859,80.3336605 9.0265459,80.3336605 C8.83245313,80.3336605 8.69054781,80.4249072 8.60082568,80.6074032 C8.51110356,80.7898993 8.46624316,81.0587564 8.46624316,81.4139828 C8.46624316,81.6813181 8.4949294,81.8961597 8.55230273,82.0585141 C8.6401938,82.306318 8.79033878,82.4302182 9.00274219,82.4302182 Z",
    id: 0,
    fill: "#414757"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.8800598,58.9938801 L11.4717346,57.8055256 L11.0377746,58.9938801 L11.8800598,58.9938801 Z M11.2813049,57.4063557 L11.6932922,57.4063557 L12.6692443,60.096175 L12.2700744,60.096175 L11.9972473,59.2905109 L10.9334045,59.2905109 L10.6422668,60.096175 L10.2687316,60.096175 L11.2813049,57.4063557 Z",
    id: "A",
    fill: "#414757"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.2519367,23.9027406 C96.4057461,23.9027406 96.5253738,23.8813785 96.6108234,23.8386537 C96.7451015,23.7715147 96.8122395,23.6506663 96.8122395,23.4761049 C96.8122395,23.3003228 96.740829,23.1819157 96.5980061,23.1208803 C96.5174392,23.0867004 96.3978115,23.0696107 96.2391193,23.0696107 L95.5890949,23.0696107 L95.5890949,23.9027406 L96.2519367,23.9027406 Z M96.3746174,25.1441957 C96.5980072,25.1441957 96.7573073,25.0794991 96.8525227,24.9501039 C96.9123374,24.8683164 96.9422443,24.7694404 96.9422443,24.653473 C96.9422443,24.4581596 96.8549649,24.3251043 96.6804035,24.2543031 C96.5876296,24.2164611 96.4649502,24.1975404 96.3123615,24.1975404 L95.5890949,24.1975404 L95.5890949,25.1441957 L96.3746174,25.1441957 Z M95.2320393,22.7656557 L96.3874348,22.7656557 C96.7023777,22.7656557 96.9263745,22.8596489 97.0594318,23.0476381 C97.1375572,23.1587226 97.1766193,23.2868952 97.1766193,23.4321596 C97.1766193,23.6018382 97.128402,23.7409969 97.031966,23.84964 C96.9819169,23.9070134 96.9098962,23.9595031 96.8159016,24.0071107 C96.9538417,24.0596012 97.0569901,24.1188047 97.1253498,24.184723 C97.2462,24.3019111 97.3066242,24.4636527 97.3066242,24.6699525 C97.3066242,24.8432932 97.2523035,25.000152 97.1436604,25.1405336 C96.981306,25.3504956 96.7231299,25.455475 96.3691242,25.455475 L95.2320393,25.455475 L95.2320393,22.7656557 Z",
    id: "B",
    fill: "#414757"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.3495367,80.8024105 L29.3495367,80.549725 C29.587575,80.5265315 29.753589,80.4877746 29.8475836,80.433453 C29.9415782,80.3791315 30.0117679,80.2506537 30.0581549,80.048016 L30.3181646,80.048016 L30.3181646,82.6591 L29.9666021,82.6591 L29.9666021,80.8024105 L29.3495367,80.8024105 Z",
    id: 1,
    fill: "#414757"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.1078375,82.6591 C53.1200446,82.4332688 53.166736,82.2367376 53.2479132,82.0695004 C53.3290903,81.9022632 53.487475,81.7502872 53.7230719,81.6135678 L54.0746344,81.4103207 C54.2321059,81.3187675 54.3425784,81.2406433 54.4060553,81.1759457 C54.5061534,81.0746268 54.5562018,80.9586612 54.5562018,80.8280453 C54.5562018,80.6754567 54.5104258,80.5543031 54.4188727,80.464581 C54.3273195,80.3748588 54.2052504,80.3299984 54.0526617,80.3299984 C53.8268305,80.3299984 53.6705821,80.4154468 53.5839117,80.5863461 C53.5375248,80.6778993 53.5118903,80.8048511 53.5070074,80.9672055 L53.1719244,80.9672055 C53.1755865,80.7389328 53.2177004,80.5527775 53.2982672,80.4087338 C53.4410902,80.1548263 53.6931628,80.0278744 54.0544928,80.0278744 C54.3547872,80.0278744 54.5742064,80.1090504 54.7127569,80.2714047 C54.8513074,80.433759 54.9205816,80.6144213 54.9205816,80.8133969 C54.9205816,81.0233589 54.8467298,81.2028004 54.699024,81.351727 C54.6135744,81.4383973 54.4603777,81.5433767 54.2394293,81.6666684 L53.9885748,81.8058285 C53.8689453,81.8717468 53.7749521,81.9346124 53.7065924,81.9944271 C53.5845215,82.1006289 53.5076179,82.2184255 53.4758795,82.3478207 L54.9077643,82.3478207 L54.9077643,82.6591 L53.1078375,82.6591 Z",
    id: 2,
    fill: "#414757"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.5018003,81.2684948 C77.500604,81.26816 77.4994053,81.2678279 77.4982043,81.2674984 L77.5018003,81.2684948 Z M77.5018003,81.2684948 C77.638018,81.3066131 77.7445453,81.3792173 77.8213854,81.4863095 C77.8989005,81.5943422 77.9376574,81.726482 77.9376574,81.8827328 C77.9376574,82.1329782 77.8552608,82.3368336 77.690465,82.4943051 C77.5256693,82.6517766 77.291907,82.7305111 76.9891711,82.7305111 C76.6791109,82.7305111 76.4541986,82.6453679 76.3144274,82.475079 C76.1746562,82.3047901 76.1047717,82.0975778 76.1047717,81.8534359 L76.44901,81.8534359 C76.4636585,82.0231145 76.4953964,82.1464043 76.5442248,82.223309 C76.6296745,82.3612491 76.7840919,82.4302182 77.0074816,82.4302182 C77.1808224,82.4302182 77.3199811,82.3838319 77.4249621,82.291058 C77.5299431,82.1982841 77.5824328,82.0786564 77.5824328,81.9321713 C77.5824328,81.7515063 77.5271965,81.6251648 77.4167224,81.553143 C77.3062482,81.4811211 77.1527463,81.4451107 76.9562121,81.4451107 C76.9342393,81.4451107 76.9119617,81.4454159 76.8893786,81.4460263 C76.8667955,81.4466366 76.8439075,81.4475521 76.8207141,81.4487729 L76.8207141,81.1576352 C76.8548939,81.1612973 76.8835802,81.1637387 76.9067736,81.1649594 C76.9299671,81.1661801 76.9549913,81.1667904 76.9818469,81.1667904 C77.1051385,81.1667904 77.2064559,81.1472594 77.285802,81.1081967 C77.4249628,81.039837 77.4945422,80.9177679 77.4945422,80.7419857 C77.4945422,80.6113699 77.4481559,80.5106629 77.355382,80.4398617 C77.2626081,80.3690606 77.154577,80.3336605 77.0312854,80.3336605 C76.8115577,80.3336605 76.6595817,80.406902 76.5753527,80.5533871 C76.5289658,80.6339539 76.5027209,80.7486989 76.4966174,80.8976254 L76.1706896,80.8976254 C76.1706896,80.7023119 76.2097518,80.5362979 76.2878771,80.3995785 C76.4221552,80.1554367 76.6583589,80.0333676 76.9964953,80.0333676 C77.2638306,80.0333676 77.4707377,80.0928763 77.6172229,80.2118954 C77.763708,80.3309146 77.8369494,80.5033372 77.8369494,80.7291684 C77.8369494,80.890302 77.7936149,81.0209159 77.7069445,81.1210141 C77.6532353,81.1832679 77.5836591,81.2320942 77.4982138,81.2674945 L77.5018003,81.2684948 Z M78.5034533,80.6980404 L79.027135,82.2947201 L79.5746203,80.6980404 L79.9353381,80.6980404 L79.195592,82.6591 L78.8440295,82.6591 L78.1207629,80.6980404 L78.5034533,80.6980404 Z",
    id: "3v",
    fill: "#414757"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.2793393,79.8997006 C96.5320261,79.8997006 96.7505297,79.9485282 96.9348568,80.046185 C97.2021922,80.1865665 97.3657647,80.4325357 97.4255795,80.7841 L97.0648617,80.7841 C97.0209162,80.5875658 96.9299747,80.4444398 96.7920346,80.3547177 C96.6540944,80.2649955 96.480146,80.2201352 96.270184,80.2201352 C96.0211593,80.2201352 95.8115056,80.313518 95.6412167,80.5002865 C95.4709278,80.687055 95.3857846,80.9653726 95.3857846,81.3352475 C95.3857846,81.6550733 95.4559743,81.9153856 95.5963559,82.1161923 C95.7367374,82.316999 95.965617,82.4174008 96.2830014,82.4174008 C96.5259225,82.4174008 96.7270313,82.3469059 96.8863339,82.205914 C97.0456364,82.064922 97.1271176,81.836958 97.1307797,81.522015 L96.2884945,81.522015 L96.2884945,81.219891 L97.4695248,81.219891 L97.4695248,82.6591 L97.2351498,82.6591 L97.1472592,82.3130307 C97.0239675,82.4485294 96.9147157,82.5425226 96.8195004,82.5950131 C96.6595875,82.6853456 96.4563424,82.7305111 96.2097592,82.7305111 C95.8911541,82.7305111 95.617109,82.6273628 95.3876156,82.4210629 C95.1373702,82.1622725 95.0122494,81.8070515 95.0122494,81.3553891 C95.0122494,80.9049474 95.1343185,80.5466746 95.3784604,80.28056 C95.6103951,80.0266524 95.9106851,79.8997006 96.2793393,79.8997006 Z M98.0334896,79.9692807 L98.4637875,79.9692807 L99.8224301,82.1482357 L99.8224301,79.9692807 L100.168499,79.9692807 L100.168499,82.6591 L99.7601742,82.6591 L98.38139,80.481976 L98.38139,82.6591 L98.0334896,82.6591 L98.0334896,79.9692807 Z M101.774334,82.3478207 C101.897626,82.3478207 101.998943,82.3350034 102.078289,82.3093686 C102.219892,82.2617609 102.335857,82.1702091 102.42619,82.0347104 C102.498212,81.9260672 102.550091,81.7869085 102.581829,81.6172299 C102.60014,81.515911 102.609295,81.4219178 102.609295,81.3352475 C102.609295,81.0019938 102.543073,80.7432074 102.410626,80.5588803 C102.278179,80.3745532 102.064863,80.282391 101.770672,80.282391 L101.12431,80.282391 L101.12431,82.3478207 L101.774334,82.3478207 Z M100.758099,79.9692807 L101.847577,79.9692807 C102.217451,79.9692807 102.504314,80.1005049 102.708172,80.3629574 C102.890058,80.599775 102.980999,80.9031167 102.980999,81.2729916 C102.980999,81.5586376 102.927289,81.8168137 102.819867,82.0475277 C102.630657,82.4552446 102.305343,82.6591 101.843914,82.6591 L100.758099,82.6591 L100.758099,79.9692807 Z",
    id: "GND",
    fill: "#414757"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(36.000000, 27.000000)",
    fill: "#FF4E00",
    fillRule: "nonzero",
    stroke: "#FF4E00"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    id: "Shape",
    strokeWidth: 5
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M9.975,2.925 L8.775,2.925 C8.7,2.925 8.625,2.85 8.625,2.775 L8.625,0.825 C8.625,0.75 8.7,0.675 8.775,0.675 L9.975,0.675 C10.05,0.675 10.125,0.75 10.125,0.825 L10.125,2.775 C10.125,2.85 10.125,2.925 9.975,2.925 Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.225,2.925 L26.025,2.925 C25.95,2.925 25.875,2.85 25.875,2.775 L25.875,0.825 C25.875,0.75 25.95,0.675 26.025,0.675 L27.225,0.675 C27.3,0.675 27.375,0.75 27.375,0.825 L27.375,2.775 C27.375,2.85 27.375,2.925 27.225,2.925 Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.35,19.8 L0.15,19.8 C0.075,19.8 -7.10542736e-15,19.725 -7.10542736e-15,19.65 L-7.10542736e-15,17.7 C-7.10542736e-15,17.625 0.075,17.55 0.15,17.55 L1.35,17.55 C1.425,17.55 1.5,17.625 1.5,17.7 L1.5,19.65 C1.5,19.725 1.5,19.8 1.35,19.8 Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.85,19.8 L34.65,19.8 C34.575,19.8 34.5,19.725 34.5,19.65 L34.5,17.7 C34.5,17.625 34.575,17.55 34.65,17.55 L35.85,17.55 C35.925,17.55 36,17.625 36,17.7 L36,19.65 C36,19.725 36,19.8 35.85,19.8 Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.975,28.2 L8.775,28.2 C8.7,28.2 8.625,28.125 8.625,28.05 L8.625,26.1 C8.625,26.025 8.7,25.95 8.775,25.95 L9.975,25.95 C10.05,25.95 10.125,26.025 10.125,26.1 L10.125,28.05 C10.125,28.125 10.125,28.2 9.975,28.2 Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.6,28.2 L17.4,28.2 C17.325,28.2 17.25,28.125 17.25,28.05 L17.25,26.1 C17.25,26.025 17.325,25.95 17.4,25.95 L18.6,25.95 C18.675,25.95 18.75,26.025 18.75,26.1 L18.75,28.05 C18.75,28.125 18.75,28.2 18.6,28.2 Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.6,36.675 L17.4,36.675 C17.325,36.675 17.25,36.6 17.25,36.525 L17.25,34.575 C17.25,34.5 17.325,34.425 17.4,34.425 L18.6,34.425 C18.675,34.425 18.75,34.5 18.75,34.575 L18.75,36.525 C18.75,36.6 18.75,36.675 18.6,36.675 Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.225,28.2 L26.025,28.2 C25.95,28.2 25.875,28.125 25.875,28.05 L25.875,26.1 C25.875,26.025 25.95,25.95 26.025,25.95 L27.225,25.95 C27.3,25.95 27.375,26.025 27.375,26.1 L27.375,28.05 C27.375,28.125 27.375,28.2 27.225,28.2 Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.975,19.8 L8.775,19.8 C8.7,19.8 8.625,19.725 8.625,19.65 L8.625,17.7 C8.625,17.625 8.7,17.55 8.775,17.55 L9.975,17.55 C10.05,17.55 10.125,17.625 10.125,17.7 L10.125,19.65 C10.125,19.725 10.125,19.8 9.975,19.8 Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.6,19.8 L17.4,19.8 C17.325,19.8 17.25,19.725 17.25,19.65 L17.25,17.7 C17.25,17.625 17.325,17.55 17.4,17.55 L18.6,17.55 C18.675,17.55 18.75,17.625 18.75,17.7 L18.75,19.65 C18.75,19.725 18.75,19.8 18.6,19.8 Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.225,19.8 L26.025,19.8 C25.95,19.8 25.875,19.725 25.875,19.65 L25.875,17.7 C25.875,17.625 25.95,17.55 26.025,17.55 L27.225,17.55 C27.3,17.55 27.375,17.625 27.375,17.7 L27.375,19.65 C27.375,19.725 27.375,19.8 27.225,19.8 Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.35,11.325 L0.15,11.325 C0.075,11.325 -7.10542736e-15,11.25 -7.10542736e-15,11.175 L-7.10542736e-15,9.225 C-7.10542736e-15,9.15 0.075,9.075 0.15,9.075 L1.35,9.075 C1.425,9.075 1.5,9.15 1.5,9.225 L1.5,11.175 C1.5,11.25 1.5,11.325 1.35,11.325 Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.85,11.325 L34.65,11.325 C34.575,11.325 34.5,11.25 34.5,11.175 L34.5,9.225 C34.5,9.15 34.575,9.075 34.65,9.075 L35.85,9.075 C35.925,9.075 36,9.15 36,9.225 L36,11.175 C36,11.25 36,11.325 35.85,11.325 Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.975,11.325 L8.775,11.325 C8.7,11.325 8.625,11.25 8.625,11.175 L8.625,9.225 C8.625,9.15 8.7,9.075 8.775,9.075 L9.975,9.075 C10.05,9.075 10.125,9.15 10.125,9.225 L10.125,11.175 C10.125,11.25 10.125,11.325 9.975,11.325 Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.6,11.325 L17.4,11.325 C17.325,11.325 17.25,11.25 17.25,11.175 L17.25,9.225 C17.25,9.15 17.325,9.075 17.4,9.075 L18.6,9.075 C18.675,9.075 18.75,9.15 18.75,9.225 L18.75,11.175 C18.75,11.25 18.75,11.325 18.6,11.325 Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.225,11.325 L26.025,11.325 C25.95,11.325 25.875,11.25 25.875,11.175 L25.875,9.225 C25.875,9.15 25.95,9.075 26.025,9.075 L27.225,9.075 C27.3,9.075 27.375,9.15 27.375,9.225 L27.375,11.175 C27.375,11.25 27.375,11.325 27.225,11.325 Z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Shape",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.975,2.925 L8.775,2.925 C8.7,2.925 8.625,2.85 8.625,2.775 L8.625,0.825 C8.625,0.75 8.7,0.675 8.775,0.675 L9.975,0.675 C10.05,0.675 10.125,0.75 10.125,0.825 L10.125,2.775 C10.125,2.85 10.125,2.925 9.975,2.925 Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.225,2.925 L26.025,2.925 C25.95,2.925 25.875,2.85 25.875,2.775 L25.875,0.825 C25.875,0.75 25.95,0.675 26.025,0.675 L27.225,0.675 C27.3,0.675 27.375,0.75 27.375,0.825 L27.375,2.775 C27.375,2.85 27.375,2.925 27.225,2.925 Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.35,19.8 L0.15,19.8 C0.075,19.8 -7.10542736e-15,19.725 -7.10542736e-15,19.65 L-7.10542736e-15,17.7 C-7.10542736e-15,17.625 0.075,17.55 0.15,17.55 L1.35,17.55 C1.425,17.55 1.5,17.625 1.5,17.7 L1.5,19.65 C1.5,19.725 1.5,19.8 1.35,19.8 Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.85,19.8 L34.65,19.8 C34.575,19.8 34.5,19.725 34.5,19.65 L34.5,17.7 C34.5,17.625 34.575,17.55 34.65,17.55 L35.85,17.55 C35.925,17.55 36,17.625 36,17.7 L36,19.65 C36,19.725 36,19.8 35.85,19.8 Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.975,28.2 L8.775,28.2 C8.7,28.2 8.625,28.125 8.625,28.05 L8.625,26.1 C8.625,26.025 8.7,25.95 8.775,25.95 L9.975,25.95 C10.05,25.95 10.125,26.025 10.125,26.1 L10.125,28.05 C10.125,28.125 10.125,28.2 9.975,28.2 Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.6,28.2 L17.4,28.2 C17.325,28.2 17.25,28.125 17.25,28.05 L17.25,26.1 C17.25,26.025 17.325,25.95 17.4,25.95 L18.6,25.95 C18.675,25.95 18.75,26.025 18.75,26.1 L18.75,28.05 C18.75,28.125 18.75,28.2 18.6,28.2 Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.6,36.675 L17.4,36.675 C17.325,36.675 17.25,36.6 17.25,36.525 L17.25,34.575 C17.25,34.5 17.325,34.425 17.4,34.425 L18.6,34.425 C18.675,34.425 18.75,34.5 18.75,34.575 L18.75,36.525 C18.75,36.6 18.75,36.675 18.6,36.675 Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.225,28.2 L26.025,28.2 C25.95,28.2 25.875,28.125 25.875,28.05 L25.875,26.1 C25.875,26.025 25.95,25.95 26.025,25.95 L27.225,25.95 C27.3,25.95 27.375,26.025 27.375,26.1 L27.375,28.05 C27.375,28.125 27.375,28.2 27.225,28.2 Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.975,19.8 L8.775,19.8 C8.7,19.8 8.625,19.725 8.625,19.65 L8.625,17.7 C8.625,17.625 8.7,17.55 8.775,17.55 L9.975,17.55 C10.05,17.55 10.125,17.625 10.125,17.7 L10.125,19.65 C10.125,19.725 10.125,19.8 9.975,19.8 Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.6,19.8 L17.4,19.8 C17.325,19.8 17.25,19.725 17.25,19.65 L17.25,17.7 C17.25,17.625 17.325,17.55 17.4,17.55 L18.6,17.55 C18.675,17.55 18.75,17.625 18.75,17.7 L18.75,19.65 C18.75,19.725 18.75,19.8 18.6,19.8 Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.225,19.8 L26.025,19.8 C25.95,19.8 25.875,19.725 25.875,19.65 L25.875,17.7 C25.875,17.625 25.95,17.55 26.025,17.55 L27.225,17.55 C27.3,17.55 27.375,17.625 27.375,17.7 L27.375,19.65 C27.375,19.725 27.375,19.8 27.225,19.8 Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.35,11.325 L0.15,11.325 C0.075,11.325 -7.10542736e-15,11.25 -7.10542736e-15,11.175 L-7.10542736e-15,9.225 C-7.10542736e-15,9.15 0.075,9.075 0.15,9.075 L1.35,9.075 C1.425,9.075 1.5,9.15 1.5,9.225 L1.5,11.175 C1.5,11.25 1.5,11.325 1.35,11.325 Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.85,11.325 L34.65,11.325 C34.575,11.325 34.5,11.25 34.5,11.175 L34.5,9.225 C34.5,9.15 34.575,9.075 34.65,9.075 L35.85,9.075 C35.925,9.075 36,9.15 36,9.225 L36,11.175 C36,11.25 36,11.325 35.85,11.325 Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.975,11.325 L8.775,11.325 C8.7,11.325 8.625,11.25 8.625,11.175 L8.625,9.225 C8.625,9.15 8.7,9.075 8.775,9.075 L9.975,9.075 C10.05,9.075 10.125,9.15 10.125,9.225 L10.125,11.175 C10.125,11.25 10.125,11.325 9.975,11.325 Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.6,11.325 L17.4,11.325 C17.325,11.325 17.25,11.25 17.25,11.175 L17.25,9.225 C17.25,9.15 17.325,9.075 17.4,9.075 L18.6,9.075 C18.675,9.075 18.75,9.15 18.75,9.225 L18.75,11.175 C18.75,11.25 18.75,11.325 18.6,11.325 Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.225,11.325 L26.025,11.325 C25.95,11.325 25.875,11.25 25.875,11.175 L25.875,9.225 C25.875,9.15 25.95,9.075 26.025,9.075 L27.225,9.075 C27.3,9.075 27.375,9.15 27.375,9.225 L27.375,11.175 C27.375,11.25 27.375,11.325 27.225,11.325 Z"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMicrobitIllustration);
export default __webpack_public_path__ + "static/media/microbit-illustration.d1f14e4e1372d8f9c0908d2f45aa5b54.svg";
export { ForwardRef as ReactComponent };